import React from "react";
import ReactPlayer from "react-player/vimeo";

const VideoPlayer = ({ url, className = "", thumbnail }) => {
  return (
    <div className={`relative w-full h-full ${className}`}>
      <ReactPlayer
        url={url}
        controls
        width="100%"
        height="100%"
        light={thumbnail || true} // if thumbnail provided, show it; else play immediately
        playing={!thumbnail}       // auto-play if no thumbnail
        playIcon={
          thumbnail ? (
            <div className="text-white text-3xl font-bold bg-[rgb(234,126,93)] px-4 py-2 rounded shadow-lg">
              ▶
            </div>
          ) : null
        }
        className="absolute top-0 left-0"
      />
    </div>
  );
};

export default VideoPlayer;